const registeredTags = new Set<string>();

export function defineZenComponent(tagName: string, elementClass: CustomElementConstructor) {
  if (registeredTags.has(tagName) || customElements.get(tagName)) return;
  customElements.define(tagName, elementClass);
  registeredTags.add(tagName);
}

export function registerZenComponents() {
  void import('./account-security-section');
  void import('./app-rail');
  void import('./auth-panel');
  void import('./filter-bar');
  void import('./goal-card');
  void import('./goal-dod-rows-editor');
  void import('./goal-list');
  void import('./invite-accept');
  void import('./integration-policy-section');
  void import('./my-connections-section');
  void import('./pending-goals');
  void import('./profile-sections');
  void import('./search-box');
  void import('./search-panel');
  void import('./settings-page');
  void import('./style-profile-section');
  void import('./subtask-row');
  void import('./today-events');
  void import('./upload-file-list');
  void import('./workspace-panel');
  void import('./workspace-menu-item');
  void import('./workspace-sync-rules-section');
  void import('./work-achievement');
  void import('./work-detail');
  void import('./work-list');
}

registerZenComponents();
